function initFiguraCartDrawer() {
  'use strict';

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const scrim = document.querySelector('[data-cart-drawer-scrim]');
  const closeBtn = drawer.querySelector('[data-cart-drawer-close]');
  const body = drawer.querySelector('[data-cd-body]');
  const foot = drawer.querySelector('[data-cd-foot]');
  const titleEl = drawer.querySelector('[data-cd-title]');
  const subEl = drawer.querySelector('[data-cd-sub]');
  const shipMsgEl = drawer.querySelector('[data-cd-ship-msg]');
  const shipFillEl = drawer.querySelector('[data-cd-ship-fill]');

  const FREE_SHIP_THRESHOLD = parseInt(drawer.dataset.freeShipThreshold, 10) || 5000;
  const CART_URL = drawer.dataset.routesCartUrl || '/cart';
  const CART_ADD_URL = drawer.dataset.routesCartAddUrl || '/cart/add';
  const CART_CHANGE_URL = drawer.dataset.routesCartChangeUrl || '/cart/change';

  // ---- Money formatting (mirror Shopify shop money_format) ----
  const moneyFormat = drawer.dataset.moneyFormat || '${{amount}}';
  function formatMoney(cents) {
    const amount = (cents / 100);
    const placeholders = {
      '{{amount}}':                     amount.toFixed(2),
      '{{amount_no_decimals}}':         Math.round(amount).toString(),
      '{{amount_with_comma_separator}}': amount.toFixed(2).replace('.', ','),
      '{{amount_no_decimals_with_comma_separator}}': Math.round(amount).toString().replace('.', ','),
      '{{amount_with_space_separator}}': amount.toFixed(2).replace('.', ' '),
      '{{amount_no_decimals_with_space_separator}}': Math.round(amount).toString()
    };
    let out = moneyFormat;
    for (const k in placeholders) out = out.replace(k, placeholders[k]);
    return out;
  }

  // ---- Open / close ----
  function open() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) {
      scrim.classList.add('open');
      scrim.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('open');
      scrim.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
  }
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (scrim) scrim.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('open')) close();
  });

  // ---- Free-ship bar ----
  function updateShipBar(totalPrice) {
    if (!shipFillEl || !shipMsgEl) return;
    if (totalPrice >= FREE_SHIP_THRESHOLD) {
      shipFillEl.style.width = '100%';
      shipFillEl.classList.add('full');
      shipMsgEl.innerHTML = "✓ You've unlocked <strong>free shipping</strong>.";
    } else if (totalPrice === 0) {
      shipFillEl.style.width = '0%';
      shipFillEl.classList.remove('full');
      shipMsgEl.textContent = 'Free shipping at ' + formatMoney(FREE_SHIP_THRESHOLD) + '.';
    } else {
      const pct = (totalPrice / FREE_SHIP_THRESHOLD) * 100;
      shipFillEl.style.width = pct + '%';
      shipFillEl.classList.remove('full');
      const remaining = FREE_SHIP_THRESHOLD - totalPrice;
      shipMsgEl.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> for free shipping.';
    }
  }

  // ---- Render lines from /cart.js payload ----
  function renderCart(cart) {
    const count = cart.item_count;
    if (titleEl) titleEl.textContent = count + (count === 1 ? ' item' : ' items');
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
    updateShipBar(cart.total_price);

    if (count === 0) {
      body.innerHTML = `
        <div class="cd-empty">
          <div class="cd-empty-mark" aria-hidden="true">
            <svg viewBox="0 0 48 48" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="24" cy="24" r="18"/>
              <path d="M14 22c2 3 6 5 10 5s8-2 10-5"/>
              <circle cx="18" cy="18" r="1" fill="currentColor"/>
              <circle cx="30" cy="18" r="1" fill="currentColor"/>
            </svg>
          </div>
          <div class="cd-empty-title">Your cart is empty.</div>
          <div class="cd-empty-sub">Nothing in here yet. The Roto is a good place to start.</div>
          <a href="/collections/all" class="cd-btn cd-btn-primary" style="margin-top: 1.25rem;">Browse objects</a>
        </div>`;
      foot.hidden = true;
      return;
    }
    foot.hidden = false;

    body.innerHTML = cart.items.map(item => {
      const productTitle = displayProductTitle(item);
      const img = item.image
        ? `<img src="${item.image.replace(/(\.[^./]+)(\?.*)?$/, '_160x$1$2')}" alt="${escapeHtml(productTitle)}" loading="lazy">`
        : '';
      const variantLabel = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<div class="cd-line-cw"><span class="cd-dot"></span><span>${escapeHtml(item.variant_title)}</span></div>`
        : '';
      return `
        <div class="cd-line" data-cd-line data-key="${item.key}">
          <a href="${item.url}" class="cd-line-img">${img}</a>
          <div class="cd-line-info">
            <div class="cd-line-top">
              <a href="${item.url}" class="cd-line-name">${escapeHtml(productTitle)}</a>
              <button type="button" class="cd-line-rm" data-cd-act="rm" data-key="${item.key}" aria-label="Remove">×</button>
            </div>
            ${variantLabel}
            <div class="cd-line-bot">
              <div class="cd-qty">
                <button type="button" data-cd-act="dec" data-key="${item.key}" aria-label="Decrease">−</button>
                <span data-cd-qty>${item.quantity}</span>
                <button type="button" data-cd-act="inc" data-key="${item.key}" aria-label="Increase">+</button>
              </div>
              <div class="cd-line-price">${formatMoney(item.final_line_price)}</div>
            </div>
          </div>
        </div>`;
    }).join('');
  }

  function displayProductTitle(item) {
    return item.handle === 'the-roto' ? 'Betterway × Figura Roto' : item.product_title;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // ---- Sync header cart count + bump ----
  function syncHeaderCart(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
    document.querySelectorAll('.nav-cart').forEach(c => {
      c.classList.remove('bump');
      void c.offsetWidth;
      c.classList.add('bump');
    });
  }

  // ---- Fetch + render cart ----
  async function refreshCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return null;
    const cart = await res.json();
    renderCart(cart);
    syncHeaderCart(cart.item_count);
    return cart;
  }

  // ---- Line item actions ----
  body.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cd-act]');
    if (!btn) return;
    const key = btn.dataset.key;
    const act = btn.dataset.cdAct;
    if (!key || !act) return;

    const lineEl = btn.closest('[data-cd-line]');
    const qtyEl = lineEl ? lineEl.querySelector('[data-cd-qty]') : null;
    const currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    let newQty = currentQty;
    if (act === 'inc') newQty = currentQty + 1;
    else if (act === 'dec') newQty = Math.max(0, currentQty - 1);
    else if (act === 'rm') newQty = 0;

    const res = await fetch(CART_CHANGE_URL + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    });
    if (res.ok) {
      const cart = await res.json();
      renderCart(cart);
      syncHeaderCart(cart.item_count);
    }
  });

  // ---- Intercept add-to-cart form submits ----
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    // Skip if explicit opt-out
    if (form.dataset.noDrawer === 'true') return;
    // Skip if it's a checkout-button submit (different action handled by browser)
    e.preventDefault();

    const formData = new FormData(form);
    const submitBtn = form.querySelector('[type="submit"]');
    const originalLabel = submitBtn ? submitBtn.innerHTML : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.busy = 'true';
    }

    try {
      const res = await fetch(CART_ADD_URL + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('Add to cart failed', err);
        return;
      }
      await refreshCart();
      open();
    } catch (err) {
      console.error('Cart drawer add error', err);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.dataset.busy = 'false';
        if (originalLabel != null) submitBtn.innerHTML = originalLabel;
      }
    }
  });

  // ---- Open drawer when clicking the header cart link ----
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (!link) return;
    // Only intercept when modifier keys aren't held (let cmd-click open in tab)
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    refreshCart().then(open);
  });

  // ---- Public API ----
  window.FiguraCartDrawer = { open, close, refresh: refreshCart };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFiguraCartDrawer);
} else {
  initFiguraCartDrawer();
}
